// extracted by mini-css-extract-plugin
export var chevronIcon = "_64-2";
export var teamName = "_64-1";
export var teamSwitcherButton = "_64-0";